import {Component} from '@angular/core';

import {ControlWidget} from '../../widget';

@Component({
  selector: 'app-sf-range-widget',
  templateUrl: './sf-range-widgets.component.html'
})
export class RangeWidgetComponent extends ControlWidget {
}
